import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useFeatureFlags } from '../hooks/useFeatureFlags';
import { Lock } from 'lucide-react';

interface PlanGateProps {
  feature: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export default function PlanGate({ feature, children, fallback }: PlanGateProps) {
  const { hasFeature, requiredPlan } = useFeatureFlags();

  if (hasFeature(feature)) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  const plan = requiredPlan(feature);

  return (
    <div className="relative rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 p-6">
      <div className="flex flex-col items-center text-center">
        <div className="w-12 h-12 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center mb-3">
          <Lock className="w-6 h-6 text-gray-400 dark:text-gray-500" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
          Upgrade Required
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
          This feature requires the <span className="font-medium capitalize">{plan}</span> plan or higher.
        </p>
        <Link
          to="/billing"
          className="px-4 py-2 bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium rounded-lg transition-colors"
        >
          Upgrade Plan
        </Link>
      </div>
    </div>
  );
}
